export const GET_BOOKING_LIST = 'GET_BOOKING_LIST';
export const GET_BOOKING_LIST_SUCCESS = 'GET_BOOKING_LIST_SUCCESS';
export const GET_BOOKING_LIST_FAILED = 'GET_BOOKING_LIST__FAILED';

export const EXPORT_BOOKING_LIST = 'EXPORT_BOOKING_LIST';
export const EXPORT_BOOKING_LIST_SUCCESS = 'EXPORT_BOOKING_LIST_SUCCESS';
export const EXPORT_BOOKING_LIST_FAILED = 'EXPORT_BOOKING_LIST__FAILED';

export const GET_BOOKING_DETAIL = 'GET_BOOKING_DETAIL';
export const GET_BOOKING_DETAIL_SUCCESS = 'GET_BOOKING_DETAIL_SUCCESS';
export const GET_BOOKING_DETAIL_FAILED = 'GET_BOOKING_DETAIL__FAILED';

export const APPROVE_BOOKING = 'APPROVE_BOOKING';
export const APPROVE_BOOKING_SUCCESS = 'APPROVE_BOOKING_SUCCESS';
export const APPROVE_BOOKING_FAILED = 'APPROVE_BOOKING__FAILED';

export const REJECT_BOOKING = 'REJECT_BOOKING';
export const REJECT_BOOKING_SUCCESS = 'REJECT_BOOKING_SUCCESS';
export const REJECT_BOOKING_FAILED = 'REJECT_BOOKING__FAILED';

export const REFUND_BOOKING = 'REFUND_BOOKING';
export const REFUND_BOOKING_SUCCESS = 'REFUND_BOOKING_SUCCESS';
export const REFUND_BOOKING_FAILED = 'REFUND_BOOKING__FAILED';

export const CONFIRM_BOOKING = 'CONFIRM_BOOKING';
export const CONFIRM_BOOKING_SUCCESS = 'CONFIRM_BOOKING_SUCCESS';
export const CONFIRM_BOOKING_FAILED = 'CONFIRM_BOOKING__FAILED';

export const OTA_SYNC_BOOKING = 'OTA_SYNC_BOOKING';
export const OTA_SYNC_BOOKING_SUCCESS = 'OTA_SYNC_BOOKING_SUCCESS';
export const OTA_SYNC_BOOKING_FAILED = 'OTA_SYNC_BOOKING__FAILED';
